import React from "react";
import {
  Navbar,
  Hero,
  Featured,
  Deals,
  RecentGamges,
  Preorder,
  Blog,
  Footer,
} from "../../components";
import ReturnImage from "./../../assets/homepage_1_background.jpg";

const HomePage = () => {
  return (
    <div className="relative">
      <img src={ReturnImage} alt=""  className="fixed top-[50px] md:top-[80px] h-screen -z-10"/>
      <Navbar />
      <Hero />
      <Featured />
      <Deals />
      <Preorder />
      <RecentGamges />
      <Blog />
      <Footer/>
    </div>
  );
};

export default HomePage;
